import React, { FC } from 'react';

import { Row } from 'antd';
import Product from 'src/components/shoppingCart/Product';
import { IShoppingGroup } from 'src/components/shoppingCart/ShoppingCart.utils';
import { IChallengeResourceConfig } from 'src/shared/models';

interface IProps {
  config: IChallengeResourceConfig;
  group: IShoppingGroup;
  handleChangeQuantity: (idProduct: number, quantity: number) => void;
}

const ShoppingGroup: FC<IProps> = ({ config, group, handleChangeQuantity }) => {
  const { name, products } = group;

  const header = (
    <Row justify="center" className="shopping-products__title">
      {name}
    </Row>
  );

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="shopping-products-container">
      <>
        {header}
        {products?.map((product, index) => (
          <Product
            config={config}
            key={index}
            handleChangeQuantity={handleChangeQuantity}
            product={product}
          />
        ))}
      </>
    </div>
  );
};

export default ShoppingGroup;
